import { magnoliaServiceAPI, magnoliaServiceV2API } from '@/store/api-instance'
import { IFetchArticlesRequest } from '@/store/modules/articles/interfaces/articles/api/fetchArticles/IFetchArticlesRequest'
import { IFetchArticlesResponse } from '@/store/modules/articles/interfaces/articles/api/fetchArticles/IFetchArticlesResponse'
import { IFetchSelectedArticleRequest } from '@/store/modules/articles/interfaces/selectedArticle/api/fetchSelectedArticle/IFetchSelectedArticleRequest'

import { IArticle, ITags } from '@/store/modules/articles/interfaces/IArticle'
import { AxiosResponse } from 'axios'

export const articlesAPI = {
  async fetchArticles (dto: IFetchArticlesRequest): Promise<IFetchArticlesResponse> {
    const { isLoggedIn } = dto
    const articlesApi = isLoggedIn ? 'articles/GetArticlesNewListPL' : 'publicarticles/GetPublicArticlesNewListPL'
    const endPoint = isLoggedIn ? magnoliaServiceV2API : magnoliaServiceAPI
    delete dto.isLoggedIn
    let params: any = dto
    if (dto?.Tags?.length !== undefined) {
      params = new URLSearchParams()
      dto.Tags.forEach(t => {
        params.append('Tags', t)
      })
      delete dto.Tags
      for (const [key, value] of Object.entries(dto)) {
        params.append(key, value)
      }
      const response: AxiosResponse = await endPoint.get<IFetchArticlesResponse>(articlesApi + '?' + params.toString())
      return response.data
    }

    const response: AxiosResponse = await endPoint.get<IFetchArticlesResponse>(articlesApi, { params })
    return response.data
  },
  async fetchSelectedArticle (dto: IFetchSelectedArticleRequest): Promise<IArticle> {
    const { isLoggedIn } = dto
    const selectedArticlesApi = isLoggedIn ? 'articles' : 'publicarticles'
    const response: AxiosResponse = await magnoliaServiceAPI.get<IArticle>(`${selectedArticlesApi}${dto.path}`)
    return response.data
  },
  async fetchArticlesTag (): Promise<ITags> {
    const response: AxiosResponse = await magnoliaServiceAPI.get('articles/GetArticlesNewListTagsPL')
    return response.data
  },
  async fetchArticlesPublicTag (): Promise<ITags> {
    const response: AxiosResponse = await magnoliaServiceAPI.get('publicarticles/GetPublicArticlesNewListTags')
    return response.data
  }
}
